// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"132":"92290110","354":"1d2d63fe","418":"61f18186"}[chunkId] + ".js";
};